<template>
  <div :style="styles.base">
    <c-button ref="button" :style="computedStyle" v-bind="$props"></c-button>
    <c-dialog
      v-model="tempraryStorageBoxShow"
      :option="tempraryStorageBoxOption"
      @close="tempraryStorageBoxShow = false"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('temporary-storage-box-wrap')">
          <div :class="getCss('wrap-header')">
            <div :class="getCss('header-left')">
              {{ configurationData.boxName }}
              <span>共{{ textList.length }}项，{{ pageConfig.pageTotal }}页</span>
            </div>
            <div :class="getCss('header-right')">
              <span :style="selectOrCancelColorStyle" @click="selectOrCancelHandler">{{ selectOrCancel ? '选择' : '取消' }}</span>
            </div>
          </div>
          <div :class="getCss('body-list-wrap')" ref="containerWrap">
            <div :class="getCss('body-list-scroll')" :style="{
                width: `${7.5 * pageConfig.pageTotal}rem`,
              }"
              ref="containerContent"
              >
              <div v-for="(page, pageIndex) in pageConfig.pageTotal" :class="getCss('body-list')" :key="page">
                <!-- 当前页 -->
                <template v-if="textList.length > 0 && pageConfig.pageCurrent === pageIndex + 1">
                  <div
                    :class="getCss('product-item')"
                    v-for="(product, index) in textList"
                    :key="index"
                    @click="selectHandler(product)"
                    >
                    <span
                      v-show="!selectOrCancel"
                      :class="getCss([
                        'select-box',
                        product.isSelect ? 'select-box_checkbox' : ''
                      ])">
                    </span>
                    <img :src="product.icon" alt="">
                    <span :class="getCss('name')">{{ `${product.name} * 1` }}</span>
                    <span
                      :class="getCss('decomposition')">
                        {{ `${product.decompositionNum}${configurationData.productName}` }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div :class="getCss('empty-wrap')">
                    {{ showGetDataLoading ? '加载中~' : '暂无数据~' }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          <!-- 底部小圆点 -->
          <div :style="bottomRadioStyle" v-show="selectOrCancel" :class="getCss('bottom-min-radio')">
            <span
              v-for="(pageKey, pageIndex) in pageConfig.pageTotal"
              :key="pageKey"
              :class="getCss(['radio-item', pageConfig.pageCurrent === (pageIndex + 1)  ? 'select-page' : ''])"
              >
            </span>
          </div>
          <!-- 底部全选 -->
          <div v-show="!selectOrCancel" :style="bottomBackgroundColorStyle" :class="getCss('bottom-select')">
            <div :class="getCss('all-select-left')">
              <div :class="getCss('all-select-left-top')">
                <span
                  @click="allSelect"
                  :class="getCss(['all-select-left-radio', isAllSelect ? 'select-page' : ''])"
                  >
                </span>
                <span :class="getCss('all-select-left-text')">本页全选</span>
              </div>
              <div :class="getCss('all-select-left-bottom')">(已选{{ selectTotal }})</div>
            </div>
            <div @click="issueHandler">发放到账号</div>
            <div @click="decompositionHandler">分解为{{ configurationData.productName }}</div>
          </div>

          <!-- 左右切换分页按钮 -->
          <!-- <div v-show="selectOrCancel" :class="getCss('page-wrap')">
            <div :class="getCss('page-prev')" @click="pageChangeHandler(-1)" :style="pagePrevStyle">

            </div>
            <div :class="getCss('page-next')" @click="pageChangeHandler(1)" :style="pageNextStyle">

            </div>
          </div> -->

        </div>
      </template>
    </c-dialog>

    <!-- 分解确定弹窗 -->
    <c-dialog
      v-model="decompositionShow"
      :option="decompositionOption"
      @close="decompositionShow = false"
      @cancel="decompositionShow = false"
      @confirm="confirmHandler"
      v-transfer-dom>
      <template slot="body">
        <div :class="getCss('decomposition-wrap')">
          <div :class="getCss('decomposition-tips')">将{{ selectTotal }}个道具分解为</div>
          <img
            v-if="configurationData.productIcon"
            :class="getCss('decomposition-icon')"
            :src="configurationData.productIcon" />
          <div
            :class="getCss('decomposition-tips')">{{ idList.decomposeTotal }}个{{ configurationData.productName }}</div>
        </div>
      </template>
    </c-dialog>

    <!-- 发放确定弹窗 -->
    <c-dialog
      v-model="issueShow"
      :option="issueOption"
      @close="issueShow = false"
      @cancel="issueShow = false"
      @confirm="confirmHandler"
      v-transfer-dom>
      <template slot="body">
        <div :class="getCss('decomposition-wrap')">
          <div :class="getCss('decomposition-text')">将{{ selectTotal }}个道具发放到以下账号</div>
          <!-- <img :class="getCss('decomposition-icon')" :src="configurationData.productIcon" /> -->
          <div :class="getCss('role-info')" :style="{
            '--roleInfoBorderColor': `0.01rem solid ${popStyleTextRgba.roleInfoBorderColor}`,
          }">
            <div :class="getCss('role-info-left')">
              <div>
                <span :class="getCss('userinfo-text')" v-show="!isWX" v-text="userName"></span>
                <span :class="getCss('userinfo-text')" v-show="isWX" v-html="userName"></span>
              </div>
              <div @click="handleBindRole">切换</div>
            </div>
            <span :class="getCss('userinfo-text')" :style="tipsStyle">{{ partitionName }} - {{ roleName }}</span>
          </div>
          <div :class="getCss('decomposition-tips')" :style="tipsStyle">发放后在游戏内邮箱查收,邮箱上限120封</div>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common, baseComponents } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
// import CDialog from '../../../../ceiba-base-components/src/components/ceiba-dialog';
// import CDialog from '../../../../ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CPublicTemporaryStorageBox',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-temporary-storage-box-',
      tempraryStorageBoxShow: false, // 暂存箱弹窗控制器
      decompositionShow: false, // 分解弹窗控制器
      issueShow: false, // 发放弹窗控制器
      selectOrCancel: false, // 控制页面 是否可以选择状态
      isAllSelect: false, // 是否全选
      showGetDataLoading: false, // 请求数据加载状态控制
      isQuerying: false, // 查询中，控制接口请求频率
      textList: [], // 接口数据平铺后得到的列表 用于显示在当前页
      pageConfig: {
        pageCurrent: 1, // 当前第几页
        pageSize: 16, // 一页展示条数
        pageTotal: 1, // 总页数
        pageCount: 0, // 总条数
      },
      touchRuntimeData: {
        currentIndex: 0, // 当前页面下标
        startX: 0, // 定义X轴手指位置
        moveX: 0,  // 定义X轴移动距离
        flag: false,  // 判断是否滑动了
      }, // 滑动数据
    };
  },
  computed: {
    computedStyle() {
      const { buttonDefaultBackgroundImage = '' } = this.configurationData;
      return {
        backgroundImage: `url(${buttonDefaultBackgroundImage})`,
        backgroundSize: 'contain', // 是否拉伸
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
        position: 'static',
      };
    },
    // 暂存箱弹窗配置项
    bottomRadioStyle(){
      const { temprageBoxDefaultBackgroundImage } = this.configurationData;
      return {
        backgroundColor: !temprageBoxDefaultBackgroundImage ? "#fff" : "unset",
      };
    },
    selectOrCancelColorStyle(){
      const { temprageBoxDefaultBackgroundImage } = this.configurationData;
      return {
        backgroundColor: !temprageBoxDefaultBackgroundImage ? "#d9d9d9" : "unset",
      };
    },
    bottomBackgroundColorStyle(){
      const { temprageBoxDefaultBackgroundImage } = this.configurationData;
      return {
        backgroundColor: !temprageBoxDefaultBackgroundImage ? "#d9d9d9" : "unset",
      };
    },
    tempraryStorageBoxOption() {
      const { backgroundColor,
        color,
      } = this.styles.temprageBoxPopStyle;
      const { temprageBoxDefaultBackgroundImage } = this.configurationData;
      return  {
        footer: false,
        header: false,
        confirm: false,
        cancel: false,
        close: true,
        width: '6rem',
        height: '5rem',
        positionType: 'bottom',
        dialogStyle: Object.assign({}, {}, {
          color: color || '#242424',
          backgroundColor: backgroundColor || '#ffffff',
          backgroundImage: `url(${temprageBoxDefaultBackgroundImage})`,
          backgroundSize: 'cover', // 是否拉伸
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }),
      };
    },
    // 分解弹窗配置想
    decompositionOption() {
      return Object.assign({}, this.dialogConfig, {
        header: '确定分解',
        body: true,
        footer: true,
        confirm: true,
        dialogStyle: Object.assign({}, this.dialogConfig.dialogStyle || {}, {
          color: this.styles?.temprageBoxPopStyle?.dialogColor || '#242424',
        }),
        cancel: true,
      });
    },
    // 发放到账号弹窗配置项
    issueOption() {
      return Object.assign({}, this.dialogConfig, {
        header: '发放确定',
        body: true,
        footer: true,
        dialogStyle: Object.assign({}, this.dialogConfig?.dialogStyle || {}, {
          color: this.styles?.temprageBoxPopStyle?.dialogColor || '#242424',
        }),
        confirm: true,
        cancel: true,
      });
    },
    // 当前页面选择的数量
    selectTotal() {
      const list = this.textList.filter(item => item.isSelect);
      return list?.length;
    },
    // 选中的id列表
    idList() {
      // 查询到相同的数据，合并 对相同的id的数量并加1
      const consumeConf = Object.values(this.textList.reduce((acc, cur) => {
        if (cur.isSelect) {
          // 匹配合并的时候 cell_id 是唯一的
          if (acc[cur.cell_id]) {
            acc[cur.cell_id].quantity += 1;
            acc[cur.cell_id].decompositionNum = Number(acc[cur.cell_id].decompositionNum)
            + Number(cur.decompositionNum);
          } else {
            acc[cur.cell_id] = {
              name: cur.name,
              product_id: cur.product_id,
              cell_id: cur.cell_id,
              quantity: 1,
              decompositionNum: Number(cur.decompositionNum),
            };
          }
        }
        return acc;
      }, {}));
      // 接口需要的参数格式(id:1|id:2)： 产品id:数量（2312:1）
      let decomposeConf = '';
      // 分解或发放弹窗页面选中的产品数量
      let decomposeTotal = 0;
      consumeConf.forEach((item) => {
        decomposeConf += `${item.product_id}:${item.quantity}|`;
        decomposeTotal += Number(item.decompositionNum);
      });
      decomposeConf = decomposeConf.substring(0, decomposeConf.length - 1);
      console.log('consumeConf,decomposeConf=', consumeConf, decomposeConf, decomposeTotal);
      return { consumeConf, decomposeConf, decomposeTotal };
    },
    // 提示文本信息颜色透明度 50% 处理
    tipsStyle() {
      return {
        color: this.popStyleTextRgba.color5,
      };
    },
    // 颜色透明度处理
    popStyleTextRgba() {
      const color = this.styles?.temprageBoxPopStyle?.dialogColor || '#ffffff';
      const hexToRgba = (hex, opacity) => `rgba(${parseInt(`0x${hex.slice(1, 3)}`, 16)},${parseInt(
        `0x${hex.slice(3, 5)}`,
        16,
      )},${parseInt(`0x${hex.slice(5, 7)}`, 16)},${opacity})`;
      return {
        color5: hexToRgba(color, 0.5),
        roleInfoBorderColor: hexToRgba(color, 0.1),
      };
    },
    // 用户名
    userName() {
      return this.isLogin ? this.userInfo.nickName : '';
    },
    // 大区名
    partitionName() {
      return this.isRoleReady ? common.tool.Base64.decode(this.roleInfo.partition_name || '') : '';
    },
    // 角色名
    roleName() {
      if (this.isRoleReady) {
        return common.tool.Base64.decode(this.roleInfo.role_name || '');
      }
      return '';
    },
    isWX() {
      return common.platform.isWX;
    },
    // pagePrevStyle() {
    //   return {
    //     backgroundImage: `url(${this.configurationData.pagePrevIcon})`,
    //   };
    // },
    // pageNextStyle() {
    //   return {
    //     backgroundImage: `url(${this.configurationData.pageNextIcon})`,
    //   };
    // },
    scrollStep() {
      const  { containerWrap } = this.$refs;
      return containerWrap?.offsetWidth;
    },
  },
  watch: {
    // 处理单击时的全选按钮状态
    selectTotal(val) {
      // 选择的产品数量为当前页面产品数量时 全选
      if (val === this.textList.length) {
        this.isAllSelect = true;
        // 选择的产品数量不为当前页面产品数量时 取消全选
      } else {
        this.isAllSelect = false;
      }
      // 选择的产品数量为0时 取消全选
      if (val === 0) {
        this.isAllSelect = false;
      }
    },
  },
  async mounted() {
    await this.initialize();
  },
  methods: {
    async initialize() {
      console.log('isRoleReady', this.isRoleReady);
      // this.queryTemporaryStorageBoxData();
      this.$onRoleReady(async () => {
        console.log('this.configurationData', this.$onRoleReady);
        this.queryTemporaryStorageBoxData();
      });

      this.$refs.button.setClickHandler(this.openBoxDialog, {
        forceApp: this.configurationData.forceApp,
        forceLogin: true,
        forceRole: true,
      });
    },
    async queryTemporaryStorageBoxData() {
      this.textList = [];
      try {
        const pageConfig = {
          pageNumber: this.pageConfig.pageCurrent,
          pageSize: this.pageConfig.pageSize,
        };
        this.showGetDataLoading = true;

        if (this.isQuerying) {
          return false;
        }
        this.isQuerying = true;

        const response = await this.flowRequest({
          flowId: this.configurationData.listFlowId,
          params: {
            role: this.roleInfo,
            data: JSON.stringify(pageConfig),
          },
        });
        this.isQuerying = false;
        // const response = {
        //   ret: 0,
        //   msg: '',
        //   data: {
        //     total: 12,
        //     ret: 0,
        //     msg: '',
        //     payload: [
        //       {
        //         product_id: '1',
        //         init_quantity: 2,
        //         quantity_used: 0,
        //         quantity_scheduled: 0,
        //         cell_id: 'aaa',
        //       },
        //       {
        //         product_id: '2',
        //         init_quantity: 2,
        //         quantity_used: 0,
        //         quantity_scheduled: 0,
        //         cell_id: 'bbb',
        //       }
        //     ],
        //   },
        // };
        console.log('response==', response);

        const { ret, msg, data } = response;
        if (ret !== 0) {
          this.alert(msg);
          return false;
        }
        data.ret = parseInt(data.ret, 10);
        if (data.ret === 0) {
          this.textList = [];
          // 接口返回产品id 与 配置文件中的id 匹配
          this.configurationData.productList.forEach((conf) => {
            data.payload.forEach((currentConf) => {
              console.log('quantity', String(conf.id), String(currentConf.product_id));
              // 配置的产品id 与返回的暂存箱列表中的产品id 匹配
              if (String(conf.id) === String(currentConf.product_id)) {
                const consumeption = (currentConf?.quantity_used || 0) + (currentConf?.quantity_scheduled || 0);
                const quantity = currentConf.init_quantity - consumeption;
                // init_quantity - quantity_used - quantity_scheduled = 可用的量 这里遍历是为了将大于1的数量扁平化
                for (let i = 0; i < quantity; i++) {
                  this.textList.push({
                    ...conf,
                    ...currentConf,
                    quantity: 1,
                  });
                }
                console.log('this.textList===', this.textList);
              }
            });
          });
          // this.textList = data.list || [];
          // this.tempraryStorageBoxShow = true;
          console.log('response===', this.textList);
          this.pageConfig.pageTotal = Math.ceil(data.total / this.pageConfig.pageSize);
        } else {
          console.log('查询失败', response.msg);
          return;
        }
      } catch (error) {
        console.log('error=queryTemporaryStorageBoxData', error);
      }
      this.showGetDataLoading = false;
    },
    // 分解
    decompositionHandler() {
      if (this.idList?.consumeConf?.length === 0) return;

      this.issuseAndDecompositionObj = {
        decompositionFlowIdOrIssueFlowId: this.configurationData.decompositionFlowId,
        success: '分解成功',
        error: '分解失败',
        reportStr: 'decomposition_integral', // 发往仓库
      };
      this.decompositionShow = true;
    },
    // 发放
    issueHandler() {
      if (this.idList?.consumeConf?.length === 0) return;

      this.issuseAndDecompositionObj = {
        decompositionFlowIdOrIssueFlowId: this.configurationData.issueFlowId,
        success: '发放成功',
        error: '发放失败',
        reportStr: 'send_warehouse', // 发往仓库
      };
      this.issueShow = true;
    },
    // 分解 发放
    async confirmHandler() {
      console.log('confirmHandler', this.idList, this.textList);
      if (this.configurationData.forceApp && !this.$ast.isAPP()) {
        return this.$ast.gotoAPP();
      }
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      try {
        const response = await this.flowRequest({
          flowId: this.issuseAndDecompositionObj.decompositionFlowIdOrIssueFlowId,
          params: {
            role: this.roleInfo,
            data: JSON.stringify({
              consume_cell: this.idList?.consumeConf || [],
              decompose_conf: this.idList?.decomposeConf || '',
            }),
          },
        });
        // const response = {
        //   ret: 0,
        //   msg: '',
        //   detail: '',
        //   data: {
        //     ret: 0,
        //     msg: '',
        //     consumeStatus: 0,
        //     shipStatus: 1,
        //     shipFailList: [
        //       {
        //         cell_id: '33e584e9-74b9-4aea-8cfe-97ae50a03a7d',
        //         quantity: 2,
        //       },
        //       {
        //         cell_id: 'e226ef73-45ee-4efc-a27a-e950f0c485cb',
        //         quantity: 1,
        //       },
        //     ],
        //   },
        // };
        console.log('response=', response);
        const { ret, msg, data } = response;
        if (ret !== 0) {
          this.alert(msg);
        }
        data.ret = parseInt(data.ret, 10);
        if (data.ret === 0) {
        // shipStatus === 且 shipFailList != null 有部分失败的
          if (data?.ship_status === 1 || data?.ship_status === 2) {
            // ship_status = 1 部分 ship_status = 2 全部
            const allAndPartText = data?.ship_status === 1 ? '部分' : '全部';

            if (data?.ship_fail_list) {
              let tipsStr = '';
              this.idList?.consumeConf?.forEach((i) => {
                data?.ship_fail_list?.forEach((t) => {
                  if (i.cell_id === t.cell_id) {
                    tipsStr += `${i.name} * ${i.quantity},`;
                  }
                });
              });
              tipsStr = tipsStr.substring(0, tipsStr.length - 1);
              this.alert(`${allAndPartText}${this.issuseAndDecompositionObj.error}<br/><br/>${tipsStr}`);
              this.reportFunc(this.issuseAndDecompositionObj?.reportStr, { status: '0' }); // 部分或全部   分解/发放  失败
              console.log('tipsStr ', tipsStr);
              this.closeDialog();
              return false;
            }
          }

          this.refreshQua(); // 刷新资格
          this.reportFunc(this.issuseAndDecompositionObj?.reportStr, { status: '1' }); // 分解/发放成功
          this.alert(this.issuseAndDecompositionObj.success);
        } else {
          this.alert(this.issuseAndDecompositionObj.error || response.msg);
          this.reportFunc(this.issuseAndDecompositionObj?.reportStr, { status: '0' }); // 分解/发放失败
        }
        this.closeDialog();
      } catch (error) {
        console.log('error=queryTemporaryStorageBoxData', error);
      }
    },
    // 关闭分解、发放弹窗
    closeDialog() {
      this.pageConfig.pageCurrent = 1;
      this.queryTemporaryStorageBoxData();
      this.decompositionShow = false;
      this.issueShow = false;
    },
    // 点击 选中或取消 页面切换
    selectOrCancelHandler() {
      this.selectOrCancel = !this.selectOrCancel;
    },
    // 勾选 或 取消勾选
    selectHandler(product) {
      if (this.selectOrCancel) return;
      const select = !product.isSelect;
      this.$set(product, 'isSelect', select);
    },
    // 点击暂存想
    openBoxDialog() {
      if (this.isRoleReady) {
        this.queryTemporaryStorageBoxData();
      }
      this.tempraryStorageBoxShow = true;
      this.$nextTick(() => {
        this.initScreenScrollAndTouch();
      });
    },
    // 切换页面
    // pageChangeHandler(pageIndex) {
    //   // 当前页为首页，或当前页等于最后一页
    //   if ((this.pageConfig.pageCurrent <= 1 && pageIndex <= 0)
    //     || (this.pageConfig.pageCurrent === this.pageConfig.pageTotal && pageIndex >= 0)) {
    //     return false;
    //   }
    //   this.pageConfig.pageCurrent += pageIndex;
    //   this.queryTemporaryStorageBoxData();
    // },
    // 全选
    allSelect() {
      if (this.textList.length === 0) return;
      this.isAllSelect = !this.isAllSelect;
      this.textList.map((item) => {
        if (this.isAllSelect) {
          this.$set(item, 'isSelect', true);
        } else {
          this.$set(item, 'isSelect', false);
        }
        return item;
      });
    },
    // 切换绑定角色
    async handleBindRole() {
      try {
        const self = this;
        baseComponents.gameRoleSelect.showGameRoleSelect(this.actInfo.game_code, {}).then((roleInfo) => {
          console.log('store select role=', roleInfo);
          self.$store.dispatch('saveCurrentRole', {
            isRoleReady: true,
            roleInfo,
          });
        });
      } catch (e) {
        console.error('showGameRoleSelect fail| err=', e);
      }
    },
    // 数据上报
    reportFunc(key, obj) {
      console.log('reportFunc key obj', key, obj);
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj || {},
        };
        this.reportClickRaw(params);
        console.log(`reportFunc  to key  ${key} report  data =`, params);
      }
    },
    initScreenScrollAndTouch() {
      console.log('initScreenScrollAndTouch');
      if (this.$isInEditor) return;
      const {  containerContent } = this.$refs;
      // 4. 手指移动轮播图
      containerContent.addEventListener('touchstart', this.touchStart);
      // 移动元素touchmove 获取移动距离
      containerContent.addEventListener('touchmove', this.touchMove);
      // 手指离开touchend，根据手指移动的距离来判断是否移动到上一张或者下一张
      containerContent.addEventListener('touchend', this.touchEnd);
    },
    touchStart(e) {
      if (!this.selectOrCancel) return;
      console.log('touchstart ', e);
      e.stopPropagation();
      this.touchRuntimeData.startX = e.targetTouches[0].pageX;
    },
    touchMove(e) {
      if (!this.selectOrCancel) return;
      console.log('touchMove ', e);
      this.touchRuntimeData.moveX = e.targetTouches[0].pageX -  this.touchRuntimeData.startX;

      // 移动盒子：盒子原来的距离 + 移动的距离
      const translateX = -this.touchRuntimeData.currentIndex *  this.scrollStep + this.touchRuntimeData.moveX;
      this.moveNoTransition(this.$refs.containerContent, translateX);

      this.touchRuntimeData.flag = true;
    },
    touchEnd() {
      if (!this.selectOrCancel) return;
      console.log('touchEnd ');
      if (this.touchRuntimeData.flag) {
        // 判断如果移动距离大于50px那么就移动到下一张或上一张  横向
        if (Math.abs(this.touchRuntimeData.moveX) > 50) {
          // 如果是右滑就表示滑动到上一张，moveX>0
          if (this.touchRuntimeData.moveX > 0) {
            this.touchRuntimeData.currentIndex = this.touchRuntimeData.currentIndex  - 1;
            this.pageConfig.pageCurrent = this.pageConfig.pageCurrent - 1;
          } else {
            // 如果是左滑就表示滑动到下一张，moveX<0
            this.touchRuntimeData.currentIndex = this.touchRuntimeData.currentIndex  + 1;
            this.pageConfig.pageCurrent = this.pageConfig.pageCurrent + 1;
          }
          console.log('this.touchRuntimeData.currentIndex * this.scrollStep', this.touchRuntimeData.currentIndex * this.scrollStep);
          // 左边距
          if (this.touchRuntimeData.currentIndex * this.scrollStep < 0) {
            this.touchRuntimeData.currentIndex = 0;
            this.pageConfig.pageCurrent = 1;
            this.moveTransition(this.$refs.containerContent, 0);
            return false;
          }
          console.log('this.touchRuntimeData.currentIndex * this.scrollStep', this.scrollStep * (this.pageConfig.pageTotal - 1));
          // 右边距
          if (
            this.touchRuntimeData.currentIndex
            * this.scrollStep > this.scrollStep
            * (this.pageConfig.pageTotal - 1)
          ) {
            this.touchRuntimeData.currentIndex = this.pageConfig.pageTotal - 1;
            this.pageConfig.pageCurrent = this.pageConfig.pageTotal;
            this.moveTransition(this.$refs.containerContent, -this.touchRuntimeData.currentIndex * this.scrollStep);
            return false;
          }
          // 只有成功分页才会重新请求事件
          this.textList = [];
          this.queryTemporaryStorageBoxData();
        }
        // 只要触摸屏幕，都需要执行
        this.moveTransition(this.$refs.containerContent, - this.touchRuntimeData.currentIndex * this.scrollStep);
      }
      this.touchRuntimeData.flag = false;
    },
    moveNoTransition(obj, distance)  {
      console.log('distance no', distance);
      // eslint-disable-next-line no-param-reassign
      obj.style.transition = 'none';  // 去掉过渡效果，让container快速跳到目标位置
      // eslint-disable-next-line no-param-reassign
      obj.style.transform = `translateX(${distance}px)`;
    },
    moveTransition(obj, distance) {
      console.log('distance yes', distance);
      // eslint-disable-next-line no-param-reassign
      obj.style.transition = 'transform 300ms ease';  // 添加过渡效果，0.3s完成图片滚动
      // eslint-disable-next-line no-param-reassign
      obj.style.transform = `translateX(${distance}px)`;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
